<template>
  <section class="sidearm-mm-theme bg-black relative" data-anchor="theme">
    <div class="sidearm-mm-theme__inner relative">
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__bg absolute w-100 h-100"
        id="sidearm-mm-theme-bg"
      >
        <div class="w-100 h-100">
          <picture>
            <source
              srcset="~@/assets/themes/storm/bg.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/bg_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__bottom-lightning absolute w-100 h-100"
        id="sidearm-mm-theme-bottom-lightning"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/storm/bottom_lightning.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/bottom_lightning_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__jersey absolute w-100"
        id="sidearm-mm-theme-jersey"
      >
        <div class="w-100 ">
          <picture>
            <source
              srcset="~@/assets/themes/storm/jersey.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/jersey_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__title absolute w-100 h-100"
        id="sidearm-mm-theme-title"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/storm/title.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/title_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__top-lightning absolute w-100"
        id="sidearm-mm-theme-top-lightning"
      >
        <div class="w-100">
          <picture>
            <source
              srcset="~@/assets/themes/storm/top_lightning.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/top_lightning_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__top-smoke absolute w-100 h-100"
        id="sidearm-mm-theme-top-smoke"
      >
        <div class="w-100 h-100">
          <picture>
            <source
              srcset="~@/assets/themes/storm/top_smoke.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/storm/top_smoke_mobile.png" />
          </picture>
        </div>
      </div>

      <div
        class="sidearm-mm-theme__divider absolute w-100 h-100"
        id="sidearm-mm-theme-divider"
      >
        <div class="h-100 w-100">
          <div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["value"]
};
</script>

<style lang="scss" scoped>
.sidearm-mm-theme {
  &__inner {
    height: 300vh;
  }

  &__bg {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 0;
      max-width: none;
      min-width: 100%;
      left: 50%;
      height: 110%;
      transform: translate(-50%, 0);
    }
  }

  &__bottom-lightning {
    bottom: 0;
    left: 0;
    img {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: auto;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__jersey {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 0;
      width: 70%;
      height: auto;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__title {
    top: 100vh;
    left: 0;
    img {
      position: absolute;
      top: 0;
      width: 70%;
      height: auto;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  &__top-lightning {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 0;
      min-width: 100%;
      max-width: none;
      height: auto;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__top-smoke {
    top: 0;
    left: 0;
    img {
      position: absolute;
      top: 0;
      max-width: none;
      min-width: 100%;
      height: 120%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  &__divider {
    span {
      position: absolute;
      top: 0;
      left: 62.5%;
      transform: translate(-50%, -100vh);
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
      &::before {
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 1px;
        height: 300vh;
        content: "";
        background: $color-white;
      }
    }
  }
}

@media (max-width: #{$breakpoint-large}) {
  .sidearm-mm-theme {
    &__jersey,
    &__title {
      img {
        width: 120%;
        max-width: none;
      }
    }
  }
}
</style>
